var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isInInitialState
        ? _c("div", { staticClass: "row" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row houses-component" }, [_c("house-list")], 1),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            staticClass: "row houses-component-summary",
            attrs: { id: "houses-summary" }
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-6" },
              [
                _c("div", { staticClass: "form-group text-right" }, [
                  _c("div", { staticClass: "control-label" }, [
                    _vm._v("Våningar")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-value" }, [
                    _vm._v(_vm._s(_vm.summary.floors))
                  ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.summary.apartments, function(apartment) {
                  return _c(
                    "div",
                    {
                      staticClass: "form-group text-right",
                      attrs: { index: apartment.sizeName + apartment.area }
                    },
                    [
                      _c("label", { staticClass: "control-label" }, [
                        _vm._v(
                          _vm._s(apartment.sizeName) +
                            " (" +
                            _vm._s(apartment.area) +
                            " kvm)"
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "summary-value" }, [
                        _vm._v(_vm._s(apartment.count))
                      ])
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-6" }, [
              _c("div", { staticClass: "form-group text-left" }, [
                _c(
                  "label",
                  { staticClass: "control-label" },
                  [
                    _vm._v(
                      "\n                        BOA\n                        "
                    ),
                    _c("help-box", {
                      attrs: {
                        "message-ref": "summary-boa",
                        title: "BOA",
                        message:
                          "<strong>Boarea:</strong> Den yta som kan användas för boende och som bostadsföretaget kan få betalt för vid uthyrning. Mäts från ytterväggarnas insidor. Omfattar alla våningar ovan mark. Specialregler för sluttningsvåningar."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "summary-value" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.summary.livingArea.toLocaleString("sv-SE")) +
                      " kvm\n                    "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group text-left" }, [
                _c("div", { staticClass: "text-box-container" }, [
                  _c(
                    "label",
                    { staticClass: "control-label" },
                    [
                      _vm._v(
                        "\n                            LOA\n                            "
                      ),
                      _c("help-box", {
                        attrs: {
                          "message-ref": "summary-loa",
                          title: "LOA",
                          message:
                            "<strong>Lokalarea:</strong> Ytan för utrymmen som inrättats för annat ändamål än boende."
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "text-box-container--inner validation-error-exclamation-mark"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model.number",
                            value: _vm.nonResidentialFloorArea,
                            expression: "nonResidentialFloorArea",
                            modifiers: { number: true }
                          }
                        ],
                        staticClass: "form-control",
                        attrs: {
                          disabled: _vm.isProjectClosed,
                          type: "Number"
                        },
                        domProps: { value: _vm.nonResidentialFloorArea },
                        on: {
                          change: _vm.save,
                          keyPress: _vm.handleLoaKeyPress,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.nonResidentialFloorArea = _vm._n(
                              $event.target.value
                            )
                          },
                          blur: function($event) {
                            _vm.$forceUpdate()
                          }
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-box-unit" }, [_vm._v("kvm")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "default-value" }, [
                    _vm._v(
                      "\n                            Schablonvärde: " +
                        _vm._s(_vm.defaultNonResidentialFloorArea) +
                        "\n                        "
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("saving-notification")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12" }, [
      _c("p", [
        _vm._v(
          "\n                Har du en sluttande tomt? Tänk på att boytan minskar om du bygger souterränghus.\n            "
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Tips: mot fönsterlösa väggar kan det vara lämpligt att bygga förråd."
        )
      ]),
      _vm._v(" "),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-sm-12 text-center" }, [
      _c("h3", [_vm._v("Sammanställning")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/houseModel.vue?vue&type=template&id=5ff43108&
// module id = 506
// module chunks = 0